import SimpleBlock from './SimpleBlock';

export default SimpleBlock;
